export default __webpack_public_path__ + "static/media/project.027e83f2.png";